import React, { useEffect, useState } from 'react';
import DimpleDivider from '@tds/core-dimple-divider';
import Heading from '@tds/core-heading';

import PropTypes from 'prop-types';

import request from '../../../../utils/request';
import { FieldWrapper } from '../css';

import FileUpload from './components/fileUpload';
import FilesList from './components/filesList';

const Attachements = ({ orderData }) => {
  const { id: orderId } = orderData;
  const [filesList, setFilesList] = useState([]);

  useEffect(() => {
    request.get(`/orders/${orderId}`).then(data => {
      setFilesList(data.data.attachments);
    });
  }, []);

  const addFileToList = newFiles => {
    setFilesList([...filesList, ...newFiles]);
  };

  const removeFileFromList = id => {
    const updatedFileList = filesList.filter(file => file.id !== id);
    setFilesList(updatedFileList);
  };

  return (
    <>
      <DimpleDivider />
      <Heading level="h2" tag="h4">
        Attachements
      </Heading>
      <FieldWrapper>
        {filesList && filesList.length > 0 && (
          <FilesList
            filesList={filesList}
            orderId={orderId}
            removeFileFromList={removeFileFromList}
          />
        )}
        {<FileUpload addFileToList={addFileToList} orderId={orderId} />}
      </FieldWrapper>
    </>
  );
};

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired
};

export default Attachements;
